
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { IconOptions } from "@/types/controls";

@Component({
  components: { DropdownInput, Repeater }
})
export default class ElementStudioIconOptions extends Vue {
  @Prop()
  value!: IconOptions | null;

  get internalValue() {
    return this.value || {};
  }

  updateSuggestions(newSuggestions: string[]) {
    this.emit({
      ...this.internalValue,
      suggestions: newSuggestions
    });
  }

  emit(mediaOptions: IconOptions) {
    this.$emit("input", mediaOptions);
  }
}
